import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebaseConfig';

export const logAction = async (userId, action, details = {}, userEmail = '', idOrganizacao = '') => {
    try {
        // Sanitizar dados para evitar 'undefined' no Firestore que quebra a gravação
        const cleanDetails = details 
            ? JSON.parse(JSON.stringify(details, (key, value) => value === undefined ? null : value))
            : {};

        await addDoc(collection(db, 'audit_logs'), {
            userId: userId || null,
            userEmail: userEmail || null,
            action: action || null,
            details: cleanDetails,
            idOrganizacao: idOrganizacao || null,
            timestamp: serverTimestamp(),
            userAgent: navigator.userAgent || 'unknown'
        });
    } catch (error) {
        console.error("Erro ao registrar log de auditoria:", error);
    }
};
